import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

// Single shared fetch for /reports/studio-list — the HQ dashboard, the studio
// performance list and the studios page all read the same payload.
let cache = null;
let cachedAt = 0;
let inflight = null;
const TTL = 30000;

export const fetchStudioList = (force = false) => {
  if (!force && cache && Date.now() - cachedAt < TTL) return Promise.resolve(cache);
  if (!force && inflight) return inflight;
  inflight = api
    .get("/reports/studio-list")
    .then(({ data }) => {
      cache = data;
      cachedAt = Date.now();
      inflight = null;
      return data;
    })
    .catch((e) => {
      inflight = null;
      throw e;
    });
  return inflight;
};

export const useStudioList = (enabled = true) => {
  const [rows, setRows] = useState(cache || []);
  const [loading, setLoading] = useState(enabled && !cache);

  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    fetchStudioList()
      .then((d) => {
        if (!alive) return;
        setRows(d);
        setLoading(false);
      })
      .catch(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, [enabled]);

  const reload = useCallback(
    () => fetchStudioList(true).then((d) => setRows(d)).catch(() => {}),
    []
  );

  return { rows, loading, reload };
};
